import {COMMON_IMAGE, CURSOR, drawBorderLines, drawRectangle, getTextColor, getTrimmedText, GROUP_SECTION_WIDTH, GROUP_TYPE} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {PROJECT_STATUS} from '../../../../constants';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class ProjectGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_PROJECT, data);
	}

	refreshData(updatedProject) {
		this.data.name = updatedProject.name;
		this.data.color = updatedProject.projectColor;
		this.data.clientName = updatedProject.client ? updatedProject.client.name : null;
		this.data.status = updatedProject.status;
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		const {clientName, name, id, color, companyProjectId, companyProjectGroupId, isConnectedProject, isDisabled} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;
		const left = x + this.marginX;
		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const planning = [PROJECT_STATUS.PLANNING, PROJECT_STATUS.OPPORTUNITY].includes(data.status);

		//Subtract 1 from width and height to make room for the grey border
		drawRectangle(canvasContext, left + 16, y, width - 17 - this.marginX, height - 1, {
			backgroundColor: isDisabled ? '#d4d4d4' : planning ? '#ffffff' : color,
			borderColor: color,
			borderThickness: !isDisabled && planning ? 2 : 0,
			borderTopLeftRadius: 10,
			borderBottomLeftRadius: expanded ? 0 : 10,
		});

		drawBorderLines(canvasContext, x, y, width, height);

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		const textColor = planning || isDisabled ? '#2a2a2a' : getTextColor(color);

		//TODO check if connected
		canvasContext.fillStyle = textColor;
		//Drawing project id
		canvasContext.font = '700 10px ' + Util.getFontFamily();
		canvasContext.fillText(`${isConnectedProject ? 'X' : 'P'}${isConnectedProject ? companyProjectGroupId : companyProjectId}`, left + 30, y + (clientName ? 17 : 24));

		//Drawing project and client (if present) name
		canvasContext.font = '500 12px ' + Util.getFontFamily();
		const formattedProjectName = getTrimmedText(canvasContext, name, (isConnectedProject ? 130 : 140) + (isDisabled ? 30 : 0) - this.marginX);
		if (clientName) {
			canvasContext.fillText(formattedProjectName, left + 66, y + 18);
			canvasContext.font = '400 11px ' + Util.getFontFamily();
			const formattedClientName = getTrimmedText(canvasContext, clientName, 140 + (isDisabled ? 30 : 0) - this.marginX);
			canvasContext.fillText(formattedClientName, left + 66, y + 33);
		} else {
			canvasContext.fillText(formattedProjectName, left + (isConnectedProject ? 76 : 66), y + 25);
		}
		if (isConnectedProject) {
			canvasContext.drawImage(cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'CONNECTED_PROJECT_WHITE' : 'CONNECTED_PROJECT_BLACK']), left + 56, y + 13, 14, 14);
		}
	}
}

export default ProjectGroup;
